import PropTypes from 'prop-types'

import placeholderFactory from './factory'

export default placeholderFactory(
  'AcpSubRows',
  {
    children: PropTypes.node.isRequired,
  },
  null,
  null,
  ['AcpCol'],
)
